// extracted by mini-css-extract-plugin
module.exports = {"heading":"az_TPc","aiLegend":"az_UPc"};